<div class="container-fluid">
    <app-report reportId="productsDashboard" screen="DASHBOARDPRODUCTS"></app-report>
</div>
